// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, Router } from '@angular/router';
import { Deal, JacketType } from '@interfaces/deal.interfaces';
import { UserTypes } from '@interfaces/user.interfaces';
import { DealsService } from '@services/deals.service';
import { ErrorService } from '@services/error.service';
import { UserService } from '@services/user.service';
import { Observable, tap } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class DealResolver implements Resolve<Deal> {
    constructor(
        private dealsService: DealsService,
        private readonly router: Router,
        private readonly userService: UserService
    ) {}

    resolve(route: ActivatedRouteSnapshot): Observable<Deal> {
        const routeInfo = route[0]?.path ? route[0]?.path : route.params.dealId;

        return this.dealsService.getDeal$(parseInt(routeInfo), true).pipe(
            tap((deal) => {
                // deal is undefined if dealer doesn't have access to that deal
                // reroute dealer to their dashboard
                // check if deal is array as when a deal is not returned
                if (route['_routerState'].url.includes('/pddj')) {
                    return;
                } else if (!deal || Array.isArray(deal)) {
                    if (route['_routerState'].url.includes('/documents') || deal?.jacketTypeId === JacketType.Document) {
                        this.router.navigate(['/dashboard', 'documents']);
                    } else if (route['_routerState'].url.includes('/storage') || deal?.jacketTypeId === JacketType.Storage) {
                        this.router.navigate(['/dashboard', 'storage']);
                    } else {
                        this.userService.user.userType === UserTypes.Customer
                            ? this.router.navigate(['/main', 'vehicles'])
                            : this.router.navigate(['/dashboard', 'deals']);
                    }
                } else if (this.userService.user.userType !== UserTypes.Customer) {
                    // If deal exists but wrong jacket type is used in the url, redirect to the correct jacket type
                    if (!route['_routerState'].url.includes('/deals') && deal.jacketTypeId === JacketType.Deal) {
                        this.router.navigate(['/dashboard', 'deals', deal.dealId]);
                    } else if (!route['_routerState'].url.includes('/documents') && deal.jacketTypeId === JacketType.Document) {
                        this.router.navigate(['/dashboard', 'documents', deal.dealId]);
                    } else if (!route['_routerState'].url.includes('/storage') && deal.jacketTypeId === JacketType.Storage) {
                        this.router.navigate(['/dashboard', 'storage', deal.dealId]);
                    }
                }
            })
        );
    }
}
